import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

let detailViewMixin = {
	methods: {
		configureSiblingNavigation() {
			if (this.record.portalData.siblingLineItems) {
				let that = this
				this.currentIndex = this.record.portalData.siblingLineItems.findIndex(element => element.recordId === that.recordId);
				this.currentPage = this.currentIndex + 1
				this.siblingCount = this.record.portalDataInfo ? this.record.portalDataInfo[0].returnedCount : this.record.portalData.siblingLineItems.length
			}
		},
		goToSibling(page) {
			if (this.record.portalData.siblingLineItems && this.record.portalData.siblingLineItems[page - 1] && this.currentIndex && this.currentIndex > 0 || this.currentIndex < this.siblingCount - 1) {
				let siblingRecordId = this.record.portalData.siblingLineItems[page - 1].recordId;
				this.updateRecord({
					recordId: siblingRecordId
				})

			}
		},
		setEditMode: function (event) {
			this.setOverlay(event.editMode)
		},
		editRecord: function () {
			this.$router.go()
		},
		updateRecord: function (event) {
			console.log('About to update record with id ' + event.recordId)
			this.$router.push({name: this.restViewEntity, params: {id: event.recordId}})
		},
		getRecord: function (recordId, scripts = undefined, responseLayout = '') {

			let query;

			if (!scripts && responseLayout === '') {
				query = {
					portals: this.portals
				};
			} else if (responseLayout === '') {
				query = {
					portals: this.portals,
					scripts: scripts
				};
			} else if (!scripts) {
				query = {
					portals: this.portals,
				};
				query['layout.response'] = responseLayout
			} else {
				query = {
					portals: this.portals,
					scripts: scripts
				};
				query['layout.response'] = responseLayout
			}

			return Vue.axios.get('/3ds/api/' + this.restEntity + '/' + recordId, {
				headers: {
					'Authorization': 'Bearer ' + this.token
				},
				params: {
					query: query
				}
			})
				.catch(reason => {
					console.error(JSON.stringify(reason))
					if (reason.response.data.status === 401 && reason.response.data.title === 'Session Expired') {
						let that = this
						that.logOut().then(value => {
							that.$router.push('/', function () {
								console.log('Session Expired')
								that.pushError({
									'message': reason.response.data.title,
									'type': 'WARNING'
								})
							})
						})

					}
				})

		},
		deleteRecord: function (recordId) {
			return Vue.axios.delete('/3ds/api/' + this.restEntity + '/' + recordId, {
				data: {},
				headers: {
					'Authorization': 'Bearer ' + this.token
				}
			})
		}
	},
	created: function () {
		console.log('Created component at route named ' + this.$route.name)
		let recordId = this.$route.params.id
		this.recordId = recordId
		this.getRecord(recordId)
			.then(value => {
				console.log(JSON.stringify(value))
				this.record = value.data.data[0]

				this.configureSiblingNavigation()
			})
			.catch(reason => {
				console.error('An error occurred trying to get record ' + recordId + ' from ' + this.restEntity)
				console.error(JSON.stringify(reason))
			})
	},
	destroyed: function () {
		this.setOverlay(false)
	},
	computed: {
		editable: function () {
			return !this.locked && this.editMode
		}
	},
	data() {
		return {
			recordId: '',
			editMode: false,
			record: {
				portalData: [],
				fieldData: {}
			}
		}
	}
}

export default detailViewMixin